<template>
	<el-dialog title="编辑框架协议" v-model="frameDialogVisible" width="40%" center :close-on-click-modal = "false" @close='closecallinfo'>
		<div class="ucPanel" style="height: 668px;">
			<div class="ucPanel bgGrayBox">
				<div class="ucForm ucForm-lump auto-d3 nameLong" >
					<div class="ucFrom-row" style="margin-bottom: 20px;">
					<div class="ucForm-group-ad">		
						<div class="ucForm-group">
							<label class="ucForm-label">获奖级别</label>
							<select v-model="awardLevel" class="ucForm-control">
								<option v-for="option in awardLevels" v-bind:key="option.id" :value="option.id">
									{{option.name}}
								</option>
							</select>
						</div>
					</div>
					<div class="ucForm-group-ad">		
						<div class="ucForm-group">
							<label class="ucForm-label">获奖人</label>
							<input name="wholesalePrice" type="text" v-model="awardPerson" class="ucForm-control">
						</div>
					</div>
					<div class="ucForm-group-ad">		
						<div class="ucForm-group">
							<label class="ucForm-label">获奖时间</label>
							<el-config-provider :locale="locale">
								<el-date-picker v-model="awardDate" type="date" value-format="YYYY-MM-DD" ></el-date-picker>
							</el-config-provider>
						</div>
					</div>
					<div class="ucForm-group-ad auto-d100">
						<div class="ucForm-group">
							<label class="ucForm-label">内容备注</label>
							<textarea name="wholesalePrice" type="text" v-model="mark" :disabled="viewOnly" class="ucForm-control"></textarea>
						</div>
					</div>
					</div>
					<div v-if="viewOnly == false" class="ucForm-group-ad ucForm-group-btn auto-d100">		
						<div class="ucForm-group ucBtn-bg">
							<button class="ucBtn ucBtn-ok ucBtn-green" v-on:click="commit"><i class="iImg"></i>保存</button>
							<button class="ucBtn ucBtn-refresh ucBtn-gray" v-on:click="closecallinfo"><i class="iImg"></i>清空</button>
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>	
			
	</el-dialog>
</template>

<script>
	import {ElConfigProvider} from 'element-plus';
	import zhCn from 'element-plus/lib/locale/lang/zh-cn';
	export default {
		name: 'ZhProvider',
		components:{
			[ElConfigProvider.name]: ElConfigProvider
		},
		props: {
			msg: String
		},
		setup(){
			let locale = zhCn
			return{
				locale
			}
		},
		data: function() {
			return {
				viewOnly: false,
				frameDialogVisible:false,                                               
				id: this.$parent.editId,
				cno:this.$parent.cno,
				cid:this.$parent.id,
				cname:this.$parent.fcname,
				gName:this.$parent.gName,
				awardDate:this.$parent.awardDate,
				mark:this.$parent.amark,
				ctype:this.$parent.ctype,
				mod:this.$parent.infoMod,
				awardPerson:this.$parent.awardPerson,
				awardLevel:this.$parent.awardLevel,
				awardLevels:[]
			}
		},
		created() {
			this.frameDialogVisible = true;
			this.getCtmsCodeList();
		},
		methods: {
			getCtmsCodeList:function() {
				var self = this;
				var req = {};
				req.cmd='getCtmsCodeList';
				req.code='100090';
				this.$sknet.postJson(this.$skconf("wyvc.surl"), req, function(res) {
					this.awardLevels=res.datas.codeList;
					this.awardLevel=self.awardLevel;
				}, null, this);
			},
			commit: function() {
				var self = this;
				var req = {};
				if(this.awardPerson==''||this.awardPerson==null){
					this.$message({
						message:'请输入获奖人',
						type:'error'
					})
					return;
				}
				if(this.awardLevel==''||this.awardLevel==null){
					this.$message({
						message:'请选择获奖级别',
						type:'error'
					})
					return;
				}
				if (this.mod == 'edit') {
					req.cmd = "updateAward";
					req.id = self.id;
				} else {
					req.cmd = "insertAward";
				}
				req.cid=this.cid;
				req.awardDate=this.awardDate;
				req.awardPerson=this.awardPerson;
				req.awardLevel=this.awardLevel;
				req.mark=this.mark;
				this.$sknet.postJson(this.$skconf("wyvc.surl"), req, function(res) {
					if(res.result=='OK'){
						this.$message({
							message:'保存成功',
							type:'success'
						})
					}else{
						this.$message({
							message:'保存失败',
							type:'error'
						})
					}
					this.frameDialogVisible = true;
					this.$emit('closeawardinfo'); //通知父组件改变。
				}, null, this);
			},
			closecallinfo: function() {
				this.frameDialogVisible = true;
				this.$emit('closeawardinfo'); //通知父组件改变。
			}
		},
		mounted() {
			if (this.mod == 'add') {
				this.viewOnly = false;
			}
			//设置 viewOnly
			if (this.mod == 'edit') {
				this.viewOnly = false;
				// this.fetch();
			}
		},
		components: {
			
		}
	}
</script>

<style scoped>

</style>
